<mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid
    #chipList
    multiple
    [formControl]="control"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="onChipDropped($event)"
  >
    @for (chip of control.value; track trackChipBy($index, chip)) {
      <mat-chip-row
        color="accent"
        [value]="chip"
        (removed)="onRemoveItem(chip)"
        cdkDrag
      >
        {{ chip }}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }

    @if (!isWithAutoComplete) {
      <input
        [(ngModel)]="inputField"
        [placeholder]="placeholder"
        [matChipInputFor]="chipList"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="onAddChipFromInput($event)"
      />
    }
  </mat-chip-grid>
  @if (isWithAutoComplete) {
    <input
      [placeholder]="placeholder"
      #autoSelectInput
      [formControl]="autoCompleteFormControl"
      [matChipInputFor]="chipList"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="onAddChipFromSelectedValue($event)"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn.bind(this)"
      (optionSelected)="selected($event)"
    >
      @for (
        option of filteredOptions$ | async;
        track trackOptionBy($index, option)
      ) {
        <mat-option [value]="option.value">
          {{ option.displayName }}
        </mat-option>
      }
    </mat-autocomplete>
  }
</mat-form-field>
